module.exports = __webpack_public_path__ + "static/media/student5.69643a8f.svg";